import { render, staticRenderFns } from "./setPrice.vue?vue&type=template&id=5b9673bf&scoped=true&"
import script from "./setPrice.vue?vue&type=script&lang=js&"
export * from "./setPrice.vue?vue&type=script&lang=js&"
import style0 from "./setPrice.vue?vue&type=style&index=0&id=5b9673bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9673bf",
  null
  
)

export default component.exports